import { render, staticRenderFns } from "./RegtopicgroupSimple.vue?vue&type=template&id=1c53a4b1&"
import script from "./RegtopicgroupSimple.vue?vue&type=script&lang=js&"
export * from "./RegtopicgroupSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports